import { render, staticRenderFns } from "./WorkDetail.vue?vue&type=template&id=321c23da&"
import script from "./WorkDetail.vue?vue&type=script&lang=js&"
export * from "./WorkDetail.vue?vue&type=script&lang=js&"
import style0 from "./WorkDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports